import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { colHeaders } from "../../Constants/colHeaders";
import { Dimmer, Modal, Loader, Menu, Icon, Header, Button } from "semantic-ui-react";
import {
    createNotification,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATION_TYPE_ERROR
} from "react-redux-notify";
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg";
import { clearAllFilters, selectedClients, addNewClient, fetchFirmSettings } from "./../../actions/clients/fetchAllClients";
import ClientsHeader from "./ClientsHeader";
import { showNotification, notificationTypes } from "../../Common/Notification/showNotification";
import { messages } from "../../Constants/clients/clientConstants";

try {
    var userDetails = atob(localStorage.getItem("userDetails"));

    if (userDetails) {
        userDetails = JSON.parse(userDetails);
    }
} catch (e) {
    window.location.reload();
}

var FIRM_ID = null;
FIRM_ID = userDetails.UserContext.firmId;

class ClientPageActions extends Component {
    constructor(props) {
        super(props);
        this.errorNotification = {
            type: NOTIFICATION_TYPE_ERROR,
            duration: 5000,
            canDismiss: true,
        }
    }
    componentDidMount() {
        if (!userDetails) {
            return;
        }
        this.firmSettings = this.props.fetchFirmSettings(FIRM_ID); 
    }

    showAddClientBtn() {
        return (
            <Button
                primary
                title="Add Client/Entity"
                onClick={this.onClick}
            >Add Client/Entity
            </Button>
        );
    }
    
    onClick = () => {        
        if (this.props.firmSettings?.onlyImport == "Y") 
        {
            this.props.showNotification(messages.ONLY_IMPORT, notificationTypes.ERROR);
            return;
        }

        let isAddNewClient = true;
        this.props.addNewClient(isAddNewClient);
    };

    clearFilters() {
        this.props.clearAllFilters(true, this.props.clients);

    }
    render() {
        return (
            <Fragment>
                <Menu secondary className="">
                    <Menu.Item>
                        <ClientsHeader totalItemCount={this.props.clients.length} visibleItemCount={ this.props.rowsCount } />
                    </Menu.Item>  
                    <Menu.Menu position="right">
                        {this.props.rowsCount != this.props.clients.length ? (
                            <Menu.Item>
                                <svg className={`svg_icon xcm-icon-filter-clear size-24`}
                                    style={{ visibility: 'hidden' }}
                                    onClick={this.clearFilters.bind(this)}>
                                    <title> Clear Filters </title>
                                    <use xlinkHref={`${svg_icon_path}#xcm-icon-filter-clear`}> </use>
                                </svg>
                            </Menu.Item>
                        ) : ("")}

                        <Menu.Item>
                            {this.showAddClientBtn()}
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        clients: state.allClients.clients,
        isClearFilters: state.allClients.isClearFilters,
        rowsCount: state.allClients.rowsCount,
        isAddNewClient: state.allClients.isAddNewClient,
        createNotification: state.allClients.createNotification,
        firmSettings: state.allClients.firmSettings
    };
};


function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            clearAllFilters,
            addNewClient,
            createNotification,
            fetchFirmSettings,
            showNotification
        },
        dispatch
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientPageActions);